const DownloadSampleDoc = ({ fileName}) => {
    const downloadFile = () => {
        const fileUrl = fileName;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', fileUrl);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    return(
        <>
            <div>
      <button className="btn btn-warning" onClick={downloadFile}>
        <i className="fa fa-download me1"></i> Download File
      </button>
    </div>
        </>
    )
}

export default DownloadSampleDoc;